import { NgModule } from '@angular/core';

import { ProgressItemSortPipe } from './progress-items-sort-pipe';

@NgModule({
  declarations: [ProgressItemSortPipe],
  exports: [ProgressItemSortPipe],
})
export class SyncIndicatorPipesModule {}
